import { cn } from '@/helpers/cn'
import { usePriceFormatter } from '@/hooks/usePriceFormatter'
import { useTranslations } from '@/hooks/useTranslations'

import type React from 'react'
import type { SmallestUnitPrice as SmallestUnitPriceData } from '@/helpers/getBffPrices'

interface Props {
  smallestUnitPrice?: SmallestUnitPriceData | null
  className?: string
}

export const SmallestUnitPrice: React.FC<Props> = ({ smallestUnitPrice, className }) => {
  const { translate } = useTranslations()
  const { formatPrice } = usePriceFormatter()

  if (!smallestUnitPrice) {
    return null
  }

  const unit = translate(`page.product.details.salesUnit.${smallestUnitPrice.unit.toLowerCase()}`)

  return (
    <span className={cn('text-input-off text-xs', className)} data-testid="smallestUnitPrice">
      {`${formatPrice(smallestUnitPrice.value)} / ${unit}`}
    </span>
  )
}
